import React from 'react';
const testimonials = [
    {
        text: "Bilih transformed our business with their innovative automation solutions. Highly recommended!",
        author: "John Doe",
        position: "CEO of TechCorp",
        avatar: "https://picsum.photos/100/100?random=1"
    },
    {
        text: "The mobile app developed by Bilih exceeded our expectations. It's user-friendly and feature-rich.",
        author: "Jane Smith",
        position: "Founder of AppStart",
        avatar: "https://picsum.photos/100/100?random=2"
    },
    {
        text: "Bilih's Telegram bot has significantly improved our customer service efficiency. Great job!",
        author: "Mike Johnson",
        position: "CTO of ChatBot Inc.",
        avatar: "https://picsum.photos/100/100?random=3"
    }
];
function Testimonials() {
    return (
        <section id="testimonials" className="py-20 bg-white">
            <div className="container mx-auto px-4">
                <h2 className="text-4xl font-bold text-center mb-12 text-gray-800">What Our Clients Say</h2>
                <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-8">
                    {testimonials.map((testimonial, index) => (
                        <div key={index} className="bg-gray-100 rounded-lg p-6 shadow-md hover:shadow-lg transition-shadow duration-300">
                            <p className="text-gray-700 mb-4">"{testimonial.text}"</p>
                            <div className="flex items-center">
                                <img src={testimonial.avatar} alt={testimonial.author} className="w-12 h-12 rounded-full mr-4" />
                                <div>
                                    <h4 className="font-semibold text-gray-800">{testimonial.author}</h4>
                                    <p className="text-gray-600 text-sm">{testimonial.position}</p>
                                </div>
                            </div>
                        </div>
                    ))}
                </div>
            </div>
        </section>
    );
}

export default Testimonials;